import { getApiErrorMessage } from '../../utils/apiError';

/**
 * Operator-facing messages for supplier-order commands. Backend prose can
 * mention implementation details (FIFO or margin), so stable codes must be
 * translated here before they reach an OPERATIONS user.
 */
const SUPPLIER_ORDER_ERROR_CODE_KEYS: Record<string, string> = {
  WAREHOUSE_RECONCILIATION_REQUIRED: 'orders:supplierOrders.detail.warehouseReconciliationRequired',
  SUPPLIER_ORDER_ALLOCATED_COST_EXCEEDED: 'orders:supplierOrders.detail.allocatedCostExceeded',
};

export function getSupplierOrderErrorMessage(
  error: any,
  t: any,
  fallbackKey: string,
  fallbackParams?: Record<string, unknown>,
): string {
  const code = error?.response?.data?.code;
  if (typeof code === 'string' && SUPPLIER_ORDER_ERROR_CODE_KEYS[code]) {
    return t(SUPPLIER_ORDER_ERROR_CODE_KEYS[code], fallbackParams);
  }
  return getApiErrorMessage(error, t, fallbackKey, undefined, fallbackParams);
}
